// Range / previous-window calendar dates. Copied from MedicalAssistant
// ItemReportModal.tsx:52-76, but walked with utcDayWalk so a DST transition
// never shifts a day bucket (same approach as itemStats.ts).

import { localCalendarDate, utcDayWalk, type CalendarDate } from "@lifelog/shared";

export type ReportRange = 30 | 90 | 365 | "all";

export const REPORT_RANGES: ReportRange[] = [30, 90, 365, "all"];

export function rangeLabel(range: ReportRange): string {
  return range === "all" ? "All" : `${range}d`;
}

/** `rangeDays` local calendar dates ending today (inclusive), ascending. */
export function windowDates(rangeDays: number, timezone: string, nowIso?: string): CalendarDate[] {
  const today = localCalendarDate(nowIso ?? new Date().toISOString(), timezone);
  const out: CalendarDate[] = [];
  for (let i = rangeDays - 1; i >= 0; i--) out.push(utcDayWalk(today, -i));
  return out;
}

/** Equal-length window immediately preceding `windowDates`. */
export function prevWindowDates(rangeDays: number, timezone: string, nowIso?: string): CalendarDate[] {
  const start = windowDates(rangeDays, timezone, nowIso)[0];
  if (!start) return [];
  const out: CalendarDate[] = [];
  for (let i = rangeDays; i >= 1; i--) out.push(utcDayWalk(start, -i));
  return out;
}

/** Inclusive span from `from` to `to` (both YYYY-MM-DD), ascending. */
export function datesInclusive(from: CalendarDate, to: CalendarDate): CalendarDate[] {
  if (from > to) return [];
  const out: CalendarDate[] = [];
  let cur = from;
  while (cur <= to) {
    out.push(cur);
    cur = utcDayWalk(cur, 1);
  }
  return out;
}

export function weekStartSunday(date: CalendarDate): CalendarDate {
  const [y, m, d] = date.split("-").map(Number);
  const dow = new Date(Date.UTC(y ?? 0, (m ?? 1) - 1, d ?? 1)).getUTCDay();
  return utcDayWalk(date, -dow);
}
